import { Box, SvgIcon, Tooltip, Typography } from "@mui/material";
import { Pending, CheckCircle, Cancel } from "@mui/icons-material";
import { TimeEntry } from "models/TimeEntry";
import { formatDateTime } from "utilities/formatDateTime";
import { absenceStateToColor, absenceStateToString } from "utilities/formatAbsence";

type AbsenceStateIconProps = { entry: TimeEntry };

const AbsenceStateIcon: React.FC<AbsenceStateIconProps> = (props) => {
  const { entry } = props;

  return (
    <Tooltip
      arrow
      title={
        <Box sx={{ textAlign: "center" }}>
          <Typography fontSize="inherit">{absenceStateToString(entry.state)}</Typography>
          {entry.state !== "PENDING" && entry.inspectedAt && (
            <Typography fontSize="inherit">{formatDateTime(entry.inspectedAt)}</Typography>
          )}
        </Box>
      }
    >
      <SvgIcon color={absenceStateToColor(entry.state)}>
        <>
          {entry.state === "PENDING" && <Pending />}
          {entry.state === "APPROVED" && <CheckCircle />}
          {entry.state === "REJECTED" && <Cancel />}
        </>
      </SvgIcon>
    </Tooltip>
  );
};

export default AbsenceStateIcon;
